import type { GTag } from '#nuxt-scripts/registry/google-analytics'

export const useGtm = () => {
  const { consumer, pro } = useRuntimeConfig().public.scripts

  function initScript(id: string) {
    if (import.meta.dev || tryUseNuxtApp()?.$preview) return

    useScriptGoogleTagManager({
      id,
      scriptOptions: {
        bundle: false,
        warmupStrategy: 'dns-prefetch',
      },
    })
  }

  function initConsumerGtm() {
    initScript(consumer.id)
  }

  function initProGtm() {
    initScript(pro.id)
  }

  function trackEvent(options: Parameters<GTag> | Record<string, unknown>) {
    if (import.meta.dev || tryUseNuxtApp()?.$preview) return

    const { proxy } = useNuxtApp().$scripts.googleTagManager

    proxy.dataLayer.push(options)
  }

  return {
    trackEvent,
    initConsumerGtm,
    initProGtm,
  }
}
